import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Combinar clases Tailwind con resolución de conflictos */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
